import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, CalendarCheck, UtensilsCrossed, ChefHat, Music, Users, Megaphone, Settings, Globe, LogOut, Wallet, CreditCard, Target } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { IMAGES } from "../lib/api";

const links = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/reservations", label: "Réservations", icon: CalendarCheck },
  { to: "/admin/menu", label: "Menu", icon: UtensilsCrossed },
  { to: "/admin/menus-semaine", label: "Menu de la semaine", icon: ChefHat },
  { to: "/admin/planning", label: "Planning & Artistes", icon: Music },
  { to: "/admin/clients", label: "Clients", icon: Users },
  { to: "/admin/wallets", label: "Wallets RITAS", icon: Wallet },
  { to: "/admin/paiements", label: "Paiements", icon: CreditCard },
  { to: "/admin/marketing", label: "Offres & Marketing", icon: Target },
  { to: "/admin/promotions", label: "Promotions & Notifs", icon: Megaphone },
  { to: "/admin/parametres", label: "Paramètres", icon: Settings },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-[#050505]" data-testid="admin-layout">
      <aside className="lg:w-64 lg:min-h-screen border-b lg:border-b-0 lg:border-r border-white/10 bg-[#0a0a0a] p-5 flex lg:flex-col gap-3 overflow-x-auto lg:overflow-visible shrink-0">
        <div className="hidden lg:flex items-center gap-3 mb-6">
          <img src={IMAGES.logo} alt="Italian Club" className="h-12 w-12 object-contain rounded-full bg-white/95 p-0.5" />
          <div>
            <p className="font-serif-elegant text-lg text-[#D4AF37] font-semibold leading-tight">Italian Club</p>
            <p className="text-[10px] uppercase tracking-widest text-gray-500">Administration</p>
          </div>
        </div>
        <nav className="flex lg:flex-col gap-1 flex-1">
          {links.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${to.split("/").pop() || "dashboard"}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm whitespace-nowrap transition-colors duration-200 ${
                  isActive ? "bg-[#D4AF37]/15 text-[#D4AF37]" : "text-gray-400 hover:text-white"
                }`
              }
            >
              <Icon size={17} /> <span className="hidden sm:inline">{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="flex lg:flex-col gap-1 lg:mt-auto">
          <Link to="/" data-testid="admin-view-site" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-gray-400 hover:text-white">
            <Globe size={17} /> <span className="hidden sm:inline">Voir le site</span>
          </Link>
          <button onClick={logout} data-testid="admin-logout-btn" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-gray-400 hover:text-white">
            <LogOut size={17} /> <span className="hidden sm:inline">Déconnexion</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 p-6 lg:p-10 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
